export const houseTypeEum = [
  {
    id: 'HOUSE',
    name: '房源',
  },
  {
    id: 'CABINET',
    name: '橱柜',
  },
  {
    id: 'CARD',
    name: '一卡通',
  },
  {
    id: 'CARPORT',
    name: '车位',
  },
]

export const dealWithBlank = obj => {
  for (var i in obj) {
    if (obj[i] && isString(obj[i])) {
      obj[i] = obj[i].replace(/^\s*|\s*$/g, '')
    }
  }
  return obj
}
export const isString = str => {
  return typeof str === 'string' && str.constructor === String
}



// WEBPACK FOOTER //
// ./src/components/forms/HouseWithdrawForm/enum.js